import { Component, Input, OnInit } from '@angular/core';
import { ModalTrailerDefectComponent } from '@core/components/components/modal-trailer-defect/modal-trailer-defect.component';
import { MatDialog } from '@angular/material';
import { OrderService } from '@accounts/operator/services/order.service';
import { OrderOnRentDamageModel } from '@core/api';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-trailer-defects',
  templateUrl: './trailer-defects.component.html',
  styleUrls: ['./trailer-defects.component.scss']
})
export class TrailerDefectsComponent implements OnInit {

  @Input() id: number = null;
  loading: boolean = false;

  defects: OrderOnRentDamageModel[] = [];

  constructor(
    public dialog: MatDialog,
    private orderService: OrderService
  ) {}

  getDefects() {
    this.loading = true;

    this.orderService.getDefects(this.id)
      .pipe(finalize(() => this.loading = false))
      .subscribe(data => {
        this.defects = data;
      });
  }

  deleteDefect(defectId: number): void {
    this.loading = true;

    this.orderService.deleteDefect(this.id, defectId)
      .pipe(finalize(() => this.getDefects()))
      .subscribe();
  }

  openDefectDialog(): void {
    const dialogRef = this.dialog.open(ModalTrailerDefectComponent, {
      disableClose: true,
      width: '600px'
    });

    dialogRef.componentInstance.updateData
      .subscribe(() => {
        dialogRef.componentInstance.updateHandler((defect: OrderOnRentDamageModel) => {
          this.loading = true;

          return this.orderService.createDefect(this.id, defect)
            .pipe(finalize(() => this.getDefects()))
        });
      });
  }

  ngOnInit() {
    this.getDefects();
  }

}
